var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "oc-subtree",
      class: { "align-items-center": _vm.depth == 0 },
    },
    [
      _c(
        "div",
        {
          staticClass: "oc-node",
          class: _vm.nodeClasses,
          attrs: { draggable: _vm.diagram.update_access },
          on: {
            click: function ($event) {
              return _vm.diagram.selectNode(_vm.node)
            },
            dragstart: function ($event) {
              $event.stopPropagation()
              return _vm.diagram.onDragStart($event, _vm.node)
            },
            dragend: function ($event) {
              $event.stopPropagation()
              return _vm.diagram.onDragEnd()
            },
            dragover: function ($event) {
              $event.stopPropagation()
              return _vm.onDragOver.apply(null, arguments)
            },
            dragleave: function ($event) {
              $event.stopPropagation()
              _vm.drop_target = false
            },
            drop: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onDrop.apply(null, arguments)
            },
          },
        },
        [
          _vm.diagram.create_access ||
          _vm.diagram.update_access ||
          _vm.diagram.delete_access
            ? _c(
                "div",
                {
                  staticClass: "oc-node-actions",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm.diagram.create_access
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            "x-small": "",
                            color: "blue-grey",
                            title: "Agregar dependiente",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.diagram.$emit("addChild", _vm.node)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("add"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.diagram.update_access
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            "x-small": "",
                            color: "blue",
                            title: "Editar",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.diagram.$emit("editNode", _vm.node)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("edit"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hasChildren && _vm.expanded
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            "x-small": "",
                            color: "blue-grey",
                            title: "Contraer dependientes",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.diagram.toggle(_vm.node)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("expand_less"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.diagram.delete_access
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            "x-small": "",
                            color: "red",
                            title: "Eliminar",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.diagram.$emit("deleteNode", _vm.node)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("delete_outline"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.node.legajo
            ? _c("div", { staticClass: "oc-avatar" }, [
                _vm._v(_vm._s(_vm.initials(_vm.node.legajo))),
              ])
            : _c(
                "div",
                {
                  staticClass: "oc-avatar oc-avatar--vacant",
                  attrs: { title: "Asignar responsable" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.diagram.update_access &&
                        _vm.diagram.$emit("assignResponsible", _vm.node)
                    },
                  },
                },
                [_vm._v("+")]
              ),
          _c("div", { staticClass: "oc-node-text" }, [
            _c(
              "div",
              { staticClass: "oc-node-name", attrs: { title: _vm.node.name } },
              [_vm._v(_vm._s(_vm.node.name))]
            ),
            _vm.node.legajo
              ? _c("div", { staticClass: "oc-node-detail" }, [
                  _vm._v(
                    _vm._s(_vm.node.legajo.name) +
                      " " +
                      _vm._s(_vm.node.legajo.surname)
                  ),
                ])
              : _c("div", { staticClass: "oc-node-detail oc-vacant-label" }, [
                  _vm._v("Vacante"),
                ]),
            _vm.isPrimaryType
              ? _c("div", { staticClass: "oc-node-detail" }, [
                  _vm._v(
                    _vm._s(_vm.node.legajos_count) +
                      " " +
                      _vm._s(_vm.node.legajos_count == 1 ? "legajo" : "legajos")
                  ),
                ])
              : _vm._e(),
            !_vm.node.enabled
              ? _c("div", { staticClass: "oc-node-detail oc-vacant-label" }, [
                  _vm._v("Inactivo"),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm.hasChildren && !_vm.expanded
        ? _c(
            "div",
            {
              staticClass: "oc-collapse-toggle",
              on: {
                click: function ($event) {
                  return _vm.diagram.toggle(_vm.node)
                },
              },
            },
            [
              _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                _vm._v("expand_more"),
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.node.children.length) +
                  " " +
                  _vm._s(
                    _vm.node.children.length == 1
                      ? "dependiente"
                      : "dependientes"
                  ) +
                  " "
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.hasChildren && _vm.expanded
        ? _c(
            "div",
            { class: _vm.depth == 0 ? "oc-children-h" : "oc-children-v" },
            _vm._l(_vm.node.children, function (child) {
              return _c(
                "div",
                { key: child.id, staticClass: "oc-branch" },
                [
                  _c("OrgChartNode", {
                    attrs: { node: child, depth: _vm.depth + 1 },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }